exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-slide {\n  text-transform: uppercase;\n  margin: 0;\n  font-size: 25px;\n  margin-top: 10px; }\n\n.container-page {\n  width: 16.54in;\n  max-width: 16.54in;\n  height: 11.69in;\n  max-height: 11.69in;\n  margin: 0 auto;\n  padding: 30px;\n  overflow: hidden; }\n\nhr.top {\n  background-image: linear-gradient(135deg, #0083f4 70%, black 30%);\n  height: 3px; }\n\n.text-desc {\n  font-size: 18px;\n  font-weight: bold;\n  color: #c00000; }\n\n.card-body {\n  position: relative; }\n\n.img-brand {\n  position: absolute;\n  bottom: 0;\n  width: 10rem;\n  height: auto;\n  right: 4rem;\n  bottom: 0; }\n\n.contaner-comparison {\n  padding: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.featured-content {\n  padding: 10px; }\n\n.container-post {\n  border: 1px solid #568f72;\n  border-radius: 40px;\n  width: 100%;\n  height: 500px;\n  padding: 25px;\n  overflow-y: hidden;\n  background-color: #d9d9d9; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/brand-comparison/brand-comparison.component.scss
// module id = ../../../../../src/app/views/reports-component/brand-comparison/brand-comparison.component.scss
// module chunks = main